import * as React from "react";
import styled from "styled-components";
import { select } from "@hubper/theme";

import Text from "../../elements/Text";

type TabItemProps = {
  selected: boolean;
};

const TabItem = styled.div<TabItemProps>`
  transition: ${select.speed("normal")};
  position: relative;
  color: ${p => select.color(["grey", p.selected ? 9 : 3], p)};
  padding: ${select.space(3)};
  cursor: ${p => (p.selected ? "default" : "pointer")};
  user-select: none;

  &:hover {
    color: ${p => select.color(["grey", p.selected ? 9 : 6], p)};

    &:after {
      opacity: ${p => (p.selected ? 1 : 0.2)};
    }
  }

  &:after {
    transition: ${select.speed("slow")};
    content: " ";
    position: absolute;
    left: 0;
    bottom: -1px;
    right: 0;
    height: 2px;
    background-color: ${select.color(["primary", 5])};
    opacity: ${p => (p.selected ? 1 : 0)};
  }
`;

const TabContainer = styled.div`
  width: 100%;
  display: flex;
  border-bottom: 1px solid ${select.color(["grey", 1])};
  position: relative;
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
  items: Array<{ value: string; display: string }>;
  selectedItem: string;
  onChange: (selectedItem: string) => void;
};

function TabBar(
  { style, className, items, selectedItem, onChange }: Props,
  ref: any
) {
  return (
    <TabContainer ref={ref} style={style} className={className}>
      {items.map(item => {
        const isSelected = selectedItem === item.value;

        return (
          <TabItem
            key={item.value}
            selected={isSelected}
            onClick={() => {
              if (!isSelected) {
                onChange(item.value);
              }
            }}
          >
            <Text c="inherit" uppercase fs={-1}>
              {item.display}
            </Text>
          </TabItem>
        );
      })}
    </TabContainer>
  );
}

export default React.forwardRef(TabBar);
